import { Config } from 'config';

export const SITES_ROLE = String(Config.get('SITES_ROLE'));
